module.exports = __webpack_public_path__ + "img/banner10m.c3537995.png";